import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SpedFicalEdicao } from '@/features/sped-fiscal/page/edicao/SpedFicalEdicao';

const RouteNFSeParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar']),
        idpk: z.number(),
    }),
]);

export const Route = createFileRoute('/a/sped-fiscal/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteNFSeParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <SpedFicalEdicao {...params} />;
}
